function bodyManagerMainStep(data) {
  const body = {};
  body.price_operation_type = [];
  data.operationType.map(operation => body.price_operation_type.push({ operation_type: operation }));
  body.real_estate_type_id = data.propertyType;
  body.real_estate_sub_type_id = data.propertySubType || null;
  return body;
}

export { bodyManagerMainStep };
